import { Icon } from "pepsico-ds";
import React from "react";
import { useState } from "react";
import PhoneEmailVerification from "./phone_email_verification.jsx";
import "./update_profile_page.css";
import { useNavigate } from "react-router-dom";
const PersonalInfo = () => {
  const navigate = useNavigate();
  const [verificationMode, setVerificationMode] = useState(false);
  const [isShowPhoneEmail, setShowPhoneEmail] = useState(false);
  const handlePhoneEmailVerification = (mode) => {
    setShowPhoneEmail(true);
    setVerificationMode(mode);
  }

  const onClickCancel = () => {
    setShowPhoneEmail(false);
  }

  const navigateBack = () => {
    navigate("/myidmPortal")
  }
  return (
    <>
      {!isShowPhoneEmail ? (
        <>
        <div className="personal-container">
          <div className="personal-info">
            <div className="phone-email-head-title">
              <p className="main-heading">Validate alternate email</p>
              <p className="sub-heading">Update phone & non-pepsico email</p>
              {/* <span>Update phone & non-pepsico email</span> */}
            </div>
            <div className="phone-email-container">
              <span style={{ margin: "unset", color: "#616161", fontSize: "14px" }}>Choose a verification method</span>
              <div className="phone-email-sub-container" style={{ marginBottom: "8px", marginTop: "12px", cursor: "pointer" }} onClick={() => handlePhoneEmailVerification('phone')}>
                <Icon
                  className="phone-email-icon align-items-center"
                  alt="alt value"
                  icon="sms"
                  size="large"
                />
                <div className="phone-email-text">
                  <span className="profile-label">Phone Verification</span>
                  <span className="profile-phone-text">Standard message and data rates may apply</span>
                </div>
              </div>
              <div className="phone-email-sub-container" style={{ marginBottom: "8px", cursor: "pointer" }} onClick={() => handlePhoneEmailVerification('call')}>
                <Icon
                  className="phone-email-icon align-items-center"
                  alt="alt value"
                  icon="call"
                  size="large"
                />
                <div className="phone-email-text">
                  <span className="profile-label">Call Verification</span>
                  <span className="profile-phone-text">Standard rates may apply</span>
                </div>
              </div>
              {/* <div className="phone-email-sub-container" style={{ cursor: "pointer" }} onClick={() => handlePhoneEmailVerification('email')}>
                <Icon
                  className="phone-email-icon"
                  alt="alt value"
                  icon="mark_email_unread"
                  size="large"
                />
                <div className="phone-email-text">
                  <span className="profile-label">Email Verification</span>
                  <span className="profile-phone-text">Timing of email delivery may vary</span>
                </div>
              </div> */}
            </div>
            {/* <div className="request-gpid-content-footer row">
                <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0 px-md-0">
                    <button className="search-user-cancel-button mt-3 mb-0 px-5"  onClick={navigateBack}>
                        Cancel
                    </button>
                </div>
            </div> */}
          </div>
        </div>
        <button className="back-to-myidm-btn" onClick={() => navigateBack()}>
          <Icon
            alt="alt value"
            icon="arrow_backward"
            size="medium"
            style={{ marginLeft: '4px' }}
          />
          <span>Back to myidM</span>
        </button>
        </>
      ) : (<PhoneEmailVerification mode={verificationMode} onClickCancel={onClickCancel} />)}
    </>
  );

};
export default PersonalInfo;
